(function () {
  var roots = document.querySelectorAll('[data-mission-story-root]');
  if (!roots.length) return;

  roots.forEach(function (root) {
    var tabs = root.querySelector('[data-mission-story-tabs]');
    var buttons = Array.from(root.querySelectorAll('[data-mission-story-tab]'));
    var panels = Array.from(root.querySelectorAll('[data-mission-story-panel]'));
    if (!tabs || !buttons.length) return;

    function activate(index) {
      tabs.style.setProperty('--active-index', index);
      tabs.classList.add('is-open');
      buttons.forEach(function (button) {
        var isActive = button.dataset.index === index;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-expanded', isActive ? 'true' : 'false');
      });
      panels.forEach(function (panel) {
        panel.classList.toggle('is-active', panel.dataset.index === index);
      });
    }

    function collapse() {
      tabs.classList.remove('is-open');
      buttons.forEach(function (button) {
        button.classList.remove('is-active');
        button.setAttribute('aria-expanded', 'false');
      });
      panels.forEach(function (panel) {
        panel.classList.remove('is-active');
      });
    }

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        var alreadyOpen = tabs.classList.contains('is-open') && button.classList.contains('is-active');
        if (alreadyOpen) {
          collapse();
        } else {
          activate(button.dataset.index);
        }
      });
    });
  });
})();
